import SearchIcon from '@mui/icons-material/Search';
import {TextField} from '@mui/material';
import styled from 'styled-components';
import { styled as muiStyled } from '@mui/material/styles';
import {tokens} from "../../../theme";

export const SearchInputContainer = styled.div`
    width: 100%;
    cursor: text;
    
    svg {
        color: ${({theme}) => theme.palette.text.placeholder};
    }
`;

export const SearchIconWrapper = styled.div`
    display: flex;
    align-items: center;
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    z-index: 1;
`;

export const StyledSearchIcon = muiStyled(SearchIcon)`
    color: ${({theme}) => theme.palette.text.placeholder};
`;

export const StyledSearchTextField = styled(TextField)`
    background-color: ${({theme}) => theme.palette.background.dropzone };
    
    & .MuiInputBase-root {
        padding-top: 10px;
        padding-bottom: 10px;
        padding-right: 14px;
        height: 44px;
        box-sizing: border-box;
    }

    & .MuiInputBase-input {
        padding-left: 45px !important;
        position: relative;
        z-index: 0;
        height: 100%;
        box-sizing: border-box;
    }
`;
